"use client";
import Button from "@/components/Cards/Button";
import { TextInput } from "@/components/Inputs/TextInput";
import InfoModal from "@/components/Modal";
import Text from "@/components/Text/Text";
import { ButtonDark } from "@/stories/Button.stories";
import { Checkbox, Group, Radio } from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { z } from "zod";
import BackButton from "../BackButton";
import ErrorModal from "../ErrorModal";

export default function TageGeldZuruckGarantieLayout({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(false);
    const schema = z.object({
        msg: z.string(),
        apply: z.boolean(),
        andrede: z.string(),
        name: z.string(),
        surname: z.string(),
        email: z
            .string()
            .email()
            .refine((value) => value.length > 0, {
                message: "Bitte gib eine gültige E-Mail-Adresse ein.",
            }),
    });
    const form = useForm({
        initialValues: {
            msg: "",
            apply: false,
            andrede: "",
            name: "",
            surname: "",
            email: "",
        },
        validate: zodResolver(schema),
    });
    const router = useRouter();

    return (
        <>
            <div className="container  z-10 max-w-10xl px-3 lg:mx-auto py-40 space-y-5 lg:space-y-10">
                <BackButton
                    link="/de/fernbehandlung/jetzt-buchen"
                    title=" Ich möchte die 30-Tage-Geld-zurück-Garantie beantragen"
                />
                <h1 className=" text-black text-xl3 lg:text-5xl font-bold  leading-10 lg:leading-14">
                    Ich möchte die 30-Tage-Geld-zurück-Garantie beantragen
                </h1>
                <div className="text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    Sollte die Fernbehandlung nicht das Richtige für dich sein, kannst du
                    die Geld-zurück-Garantie ohne Begründung beanspruchen.
                </div>
                <div className="text-black text-xl3 font-bold  leading-10">
                    30-Tage-Geld-zurück-Garantie einfordern
                </div>
                <div className=" text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    Die Geld-zurück-Garantie kann in den ersten 30 Tagen ab Beginn der
                    Fernbehandlung einmalig pro Person in Anspruch genommen werden.
                </div>
                <div className="text-black text-2xl font-bold  leading-7 lg:leading-loose">
                    Bitte beachte:
                </div>
                <div className="text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    Wenn du dieses Formular absendest, wird die Fernbehandlung umgehend
                    beendet.
                </div>
                <InfoModal
                    onClose={() => setOpenModal(false)}
                    opened={openModal}
                    size="xl"
                >
                    <>
                        <Text
                            hasPretitle={false}
                            hasSubTitle={false}
                            hasText={true}
                            paddings=""
                            paragraphs={[
                                "Herzlichen Dank für deine Nachricht. Ich melde mich so rasch als möglich bei dir. Deine Anfrage wird in der Regel am selben Tag, spätestens innerhalb 48 Stunden beantwortet.",
                                "Liebe Grüsse",
                                "Rico Brunner",
                            ]}
                            title="Danke für Deine Anfrage zur 30-Tage-Geld-zurück-Garantie."
                        />
                        <div className="flex py-5 justify-end">
                            <Button
                                size={ButtonDark.args?.size}
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                hasIcon={ButtonDark.args?.hasIcon}
                                text="Home"
                                textColor={ButtonDark.args?.textColor}
                                textSize={ButtonDark.args?.textSize}
                                as="a"
                                href="/"
                            />
                        </div>
                    </>
                </InfoModal>
                <form
                    className="space-y-3"
                    onSubmit={form.onSubmit((values) => {
                        const data = {
                            msg: values.msg,
                            apply: values.apply,
                            andrede: values.andrede,
                            name: values.name,
                            surname: values.surname,
                            email: values.email,
                        };

                        sendEmail("30-Tage-Geld-zurück-Garantie beantragen", data)
                            .then(() => {
                                setOpenModal(true);
                            })
                            .catch((e) => {
                                <ErrorModal
                                    open={error}
                                    onClose={() => setError(false)}
                                />;
                            });
                    })}
                >
                    <div>
                        <TextInput
                            id="msg"
                            name="msg"
                            type="textarea"
                            label=" Deine
                            Mitteilung"
                            {...form.getInputProps("msg")}
                        />
                    </div>
                    <Checkbox
                        id="apply"
                        name="apply"
                        label=" 30-Tage-Geld-zurück-Garantie beantragen"
                        className="text-neutral-800 text-base font-bold  leading-tight"
                        {...form.getInputProps("apply")}
                    />
                    <div className="text-neutral-800 text-base font-bold  leading-tight">
                        Anrede
                    </div>
                    <Radio.Group
                        id="anrede"
                        name="anrede"
                        className="text-neutral-800 text-base font-bold  leading-tight"
                        {...form.getInputProps("andrede")}
                    >
                        <Group mt="xs">
                            <Radio value="frau" label="Frau" />
                            <Radio value="herr" label="Herr" />
                            <Radio value="divers" label="Divers" />
                        </Group>
                    </Radio.Group>
                    <TextInput
                        id="name"
                        name="name"
                        type="text"
                        label="Vorname"
                        placeholder="Hier eingeben"
                        {...form.getInputProps("name")}
                    />
                    <TextInput
                        id="surname"
                        name="surname"
                        type="text"
                        label="Nachname"
                        placeholder="Hier eingeben"
                        {...form.getInputProps("surname")}
                    />

                    <TextInput
                        id="email"
                        name="email"
                        type="email"
                        label="Deine E-Mail-Adresse"
                        placeholder="Hier eingeben"
                        {...form.getInputProps("email")}
                    />
                    <Button
                        backgroundColor={ButtonDark.args?.backgroundColor}
                        hasIcon={ButtonDark.args?.hasIcon}
                        text="Jetzt beantragen"
                        size={ButtonDark.args?.size}
                        paddings={ButtonDark.args?.paddings}
                        buttonType="submit"
                    />

                    <div className="text-black text-base font-normal  leading-tight">
                        Deine Daten werden vertraulich behandelt.
                    </div>
                </form>
            </div>
        </>
    );
}
